import { render, staticRenderFns } from "./IconArrowRight2.vue?vue&type=template&id=240a71fa&"
import script from "./IconArrowRight2.vue?vue&type=script&lang=js&"
export * from "./IconArrowRight2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports